import { useQueryClient } from '@tanstack/react-query';

import { useGrapevinePostEventsApi } from '@/features/api/hooks/grapevine-post-events/useGrapevinePostEventsApi';
import { useApiMutation } from '@/features/api/hooks/useApiMutation';
import { invalidatePostCachesForDeletedPost } from '@/features/api/utils/postCaches';

export const useDeletePost = () => {
  const queryClient = useQueryClient();
  const api = useGrapevinePostEventsApi();

  return useApiMutation({
    mutationFn: (postId: string) =>
      api.onPostDeleteRequest({ clientPostDeleteRequest: { postId } }),
    successMessageKey: 'deletePost.success',
    errorMessageKey: 'deletePost.error',
    onSuccess: ({ postId }) =>
      invalidatePostCachesForDeletedPost(queryClient, postId)
  });
};
